<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:54:43
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 17:49:59
 * @Description: 下单与支付
 -->
<template>
  <div class="order-submit">
    <slot>
      <div class="submit-button" @click="checkStatus">{{$t('upgrade_page_views_order_components_submit_button_349')}}<div
          class="payPay-button-box"
          :id="submitId"
          v-show="payType === payTypeConfig.PayPal_CheckOut"
        ></div>
      </div>
    </slot>
    <form :action="paymentObj.payUrl" method="post" id="payment-form">
      <input type="hidden" name="MerchantID" :value="paymentObj.storeId" />
      <input type="hidden" name="RespondType" value="JSON" />
      <input
        type="hidden"
        name="CheckValue"
        :value="orderInfo.paymentCheckCode"
      />
      <input
        type="hidden"
        name="TimeStamp"
        :value="Math.floor(orderInfo.createTime / 1000)"
      />
      <input type="hidden" name="Version" value="1.2" />
      <input type="hidden" name="MerchantOrderNo" :value="orderInfo.orderNo" />
      <input type="hidden" name="Amt" :value="orderInfo.currentAmount" />
      <input type="hidden" name="LoginType" value="0" />
      <input type="hidden" name="BrowserProcess" value="1" />
      <input type="hidden" name="Email" :value="email" />
      <input type="hidden" name="ItemDesc" :value="skillInfo.gameName" />
      <input type="hidden" name="ReturnURL" :value="paymentObj.hostUrl" />
      <!-- <input type="hidden" name="CREDIT" value="1" >
      <input type="hidden" name="CVS" value="1" > -->
      <input type="hidden" :name="payMethodInfo.code" value="1" />
      <input
        type="hidden"
        :name="payMethodInfo.validity"
        :value="payMethodInfo.time"
      />
    </form>
    <!-- FunPoint金流 -->
    <form :action="funPointPaymentObj.payUrl" method="post" id="funpoint-form">
      <input
        type="hidden"
        name="MerchantID"
        :value="funpointResult.MerchantID"
      />
      <input
        type="hidden"
        name="MerchantTradeNo"
        :value="funpointResult.MerchantTradeNo"
      />
      <input
        type="hidden"
        name="MerchantTradeDate"
        :value="funpointResult.MerchantTradeDate"
      />
      <input
        type="hidden"
        name="PaymentType"
        :value="funpointResult.PaymentType"
      />
      <input
        type="hidden"
        name="TotalAmount"
        :value="funpointResult.TotalAmount"
      />
      <input type="hidden" name="TradeDesc" :value="funpointResult.TradeDesc" />
      <input type="hidden" name="ItemName" :value="funpointResult.ItemName" />
      <input type="hidden" name="ReturnURL" :value="funpointResult.ReturnURL" />
      <input
        type="hidden"
        name="ChoosePayment"
        :value="funpointResult.ChoosePayment"
      />
      <input
        type="hidden"
        name="CheckMacValue"
        :value="funPointPaymentObj.nonce"
      />
      <input
        type="hidden"
        name="EncryptType"
        :value="funpointResult.EncryptType"
      />
      <input
        type="hidden"
        name="ClientBackURL"
        :value="funpointResult.ClientBackURL"
      />
    </form>
    <Tappay
      ref="tappay"
      :rechargeName="skillInfo.gameName"
      :price="payPrice"
      @submit="tappayRecharge"
    ></Tappay>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapMutations } from 'vuex';
import { getInviterUuid } from '@/api';
import BindPhone from '@/components/BindPhone/index.js';
import { Loading } from 'element-ui';
import Tappay from '@/upgrade-page/views/line-recharge/tappay.vue';
import { loadScript } from '@paypal/paypal-js';
import { Decrypt } from '@/utils/crypto-aes'

export default {
  name: 'SubmitButton',
  components: {
    Tappay
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    count: { type: Number, default: 1 }, // 小时数
    skillInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    accountInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }, // 用户账户信息
    payType: { type: String, default: 'Balance' },
    couponUuid: { default: '' }, // 優惠券id
    payPrice: { type: [String, Number], default: 0 },
    payMethodInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    noPayOrderInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isFromNew: { type: Boolean, default: false }, // 是否使用新人优惠
    skillPrice: { default: undefined } // 计费模式
  },
  computed: {
    userInfo() {
      return this.$store.state.app.userInfo || {};
    },
    paymentObj() {
      return {
        payUrl: process.env.VUE_APP_PAY_URL,
        storeId: process.env.VUE_APP_MERCHANTID, // 支付验证码
        hostUrl:
          location.protocol +
          '//' +
          location.host +
          `/user/order${
            this.$route.query.reorder
              ? '?reorder=true'
              : this.$route.query.dragonBoat
              ? '?dragonBoat=true'
              : ''
          }`, // 支付成功返回页面
        nonce: ''
      };
    },
    // 是否蓝新支付
    isLanxin() {
      const typeList = [
        this.payTypeConfig.LanXinATM,
        this.payTypeConfig.LanXinCreditCard,
        this.payTypeConfig.LanXinSupermarket
      ];
      return typeList.includes(this.payType);
    },
     // 是否随机選擇的自動約單
    isQuickMatchRandom() {
      return Decrypt(localStorage.getItem('quickMatchRandom')) === this.$route.query.quickMatchUuid
    }
  },
  watch: {
    noPayOrderInfo(newVal) {
      this.orderInfo = newVal;
    }
  },
  created() {},
  mounted() {
    // 生成paypal支付按钮
    this.renderButton();
  },
  data() {
    return {
      loadingInstance: '',
      orderNo: this.$route.query.orderNo, // 是否是已支付
      quickMatchUuid: this.$route.query.quickMatchUuid, // 是否是极速约单
      skillId: this.$route.params.skill, // 商品id
      orderInfo: {},
      funpointResult: {}, // FunPoint支付信息
      funPointPaymentObj: {
        // payUrl: 'https://payment-stage.funpoint.com.tw/Cashier/AioCheckOut/V5',
        payUrl: process.env.VUE_APP_FUNPOINT,
        nonce: ''
      },
      // 支付成功返回页面
      successUrl:
        location.protocol +
        '//' +
        location.host +
        `/user/order${
          this.$route.query.reorder
            ? '?reorder=true'
            : this.$route.query.dragonBoat
            ? '?dragonBoat=true'
            : ''
        }`,
      // 支付类型
      payTypeConfig: {
        LanXinATM: 'LanXinATM',
        LanXinCreditCard: 'LanXinCreditCard',
        LanXinSupermarket: 'LanXinSupermarket',
        PayPal_CheckOut: 'PayPal_CheckOut',
        FOMO: 'FOMO_WX_WEB',
        FUN_POINT: 'FUN_POINT',
        TAB_PAY_CARD: 'TAB_PAY_CARD',
        Balance: 'Balance',
        StripeCheckOut: 'StripeCheckOut'
      },
      // paypal提交按鈕的id
      submitId: 'submit' + ((Math.random() * 1000) | 0),
      paypalButton: null
    };
  },
  methods: {
    ...mapMutations('app', ['SET_USER_INFO']),
    async createNormalOrder() {
      // 是否已綁定手機
      const isBind = await this.isBindPhone();
      if (!isBind && this.isFromNew) {
        this.$nextTick(() => {
          this.loadingInstance.close();
        });
        this.$message(i18n.t('upgrade_page_views_order_components_submit_button_350'));
        BindPhone({ isOrder: true }).then(() => {
          this.$emit('bindPhoneComplete');
        });
        return;
      }
      const { count, skillId, quickMatchUuid } = this;
      // tappay支付
      if (this.payType === this.payTypeConfig.TAB_PAY_CARD) {
        this.openTappayDialog();
        return;
      }
      // stripe支付
      if (this.payType === this.payTypeConfig.StripeCheckOut) {
        this.stripeRecharge();
        return;
      }
      // FOMO支付
      if (this.payType === this.payTypeConfig.FOMO) {
        this.fomopayRecharge();
        return;
      }
      await this.$parent.getUserAccount();

      // 余额不足
      if (
        this.payPrice > this.accountInfo.balance &&
        this.payType === 'Balance'
      ) {
        this.$nextTick(() => {
          this.loadingInstance.close();
        });
        return this.recharge();
      }
      if (this.isFromNew) {
        // window.gtag('OrderPage', 'FreeGame', 'Confirm');
      }
      this.setLoading();
      // 极速约单
      if (quickMatchUuid) return this.createGrabOrder();
      // 待支付狀態的訂單
      if (this.orderNo) {
        // 不需要支付
        this.payOrder();
        return;
      }
      const params = {
        count,
        playerSkillId: skillId,
        paymentMethod: this.isFromNew ? 'Balance' : this.payType || 'Balance',
        priceType: this.skillInfo.selfSpreadFlag ? 'SelfSpread' : null,
        couponUuid: this.couponUuid,
        skillPrice: this.skillPrice.id ? this.skillPrice : undefined,
        email: this.email,
        successUrl: this.successUrl
      };
      window.localStorage.setItem('OrderEmail', this.email);
      this.$http
        .post('/order/create', params)
        .then(({ data }) => {
          if (data) {
            this.orderInfo = data;
            this.paymentObj.nonce = data.paymentCheckCode;
            window.fbq('track', 'Purchase', {
              value: this.payPrice,
              currency: 'USD'
            });
            if (this.payType === 'Balance') {
              this.reportInviterInfo();
              this.$message.success(i18n.t('upgrade_page_views_order_components_submit_button_351'));
              if (this.$route.query.reorder) {
                // window.gtag('reorder_click', 'reorder', this.userInfo.uuid)
              }
              if (this.$route.query.dragonBoat) {
                // window.gtag('goorder_paysuccess', 'DragonBoatFestival', this.$store.state.app.userInfo ? this.$store.state.app.userInfo.uuid : '')
              }
              this.$store.dispatch('app/getUserInfo');
              this.$nextTick(() => {
                this.loadingInstance.close();
              });
              this.gotoChat(); // 新开页面聊天
              // this.$router.replace({ // 当前为订单页
              //   name: 'UserOrder'
              // });
              this.$router.go(-1);
            } else if (this.payType === this.payTypeConfig.FUN_POINT) {
              this.funPointPaymentObj.nonce = data.paymentCheckCode;
              this.funpointResult = data.result;
              console.log('this.funpointResult', this.funpointResult);
              this.payOrder();
            } else {
              this.payOrder();
            }
          }
          this.$nextTick(() => {
            this.loadingInstance.close();
          });
        })
        .catch(err => {
          console.log(err);
          this.$nextTick(() => {
            this.loadingInstance.close();
          });
          // todo
          this.showFailMessage(err);
        });
    },
    /**
     * @description 極速約單的訂單,只可用與額支付
     */
    createGrabOrder() {
      const { count, quickMatchUuid, skillId } = this;
      this.$http
        .post('/match/quick/finish', {
          count,
          uuid: quickMatchUuid,
          playerSkillId: skillId,
          paymentMethod: 'Balance',
          couponUuid: this.couponUuid,
          quickMatchRandom: this.isQuickMatchRandom
        })
        .then(({ data }) => {
          if (data) {
            this.$nextTick(() => {
              this.loadingInstance.close();
            });
            this.$message.success(i18n.t('upgrade_page_views_order_components_submit_button_351'));
            this.gotoChat();
            this.$router.replace({
              name: 'OrderList'
            });
          }
        })
        .catch(err => {
          this.$nextTick(() => {
            this.loadingInstance.close();
          });
          this.showFailMessage(err);
        });
    },
    /**
     * @description: 支付前状态检查
     */
    checkStatus() {
      if (this.payType != this.payTypeConfig.PayPal_CheckOut) {
        // 蓝新支付输入邮箱时要检查邮箱是否有效
        if (this.isLanxin) {
          // 邮箱是否正常
          if (!/^(\w+\.)*\w+@\w+(.\w+)+$/.test(this.email) && this.email)
            return this.$message.error(i18n.t('upgrade_page_views_order_confirm_order_289'));
        }
        let text = '';
        switch (this.payType) {
          case this.payTypeConfig.Balance:
            text = i18n.t('upgrade_page_views_order_components_submit_button_352');
            break;
          case this.payTypeConfig.FUN_POINT:
            text = i18n.t('upgrade_page_views_order_components_submit_button_353');
            break;
          case this.payTypeConfig.PayPal_CheckOut:
            text = i18n.t('upgrade_page_views_order_components_submit_button_354');
            break;
          case this.payTypeConfig.TAB_PAY_CARD:
            text = i18n.t('upgrade_page_views_order_components_submit_button_355');
            break;
          case this.payTypeConfig.FOMO:
            text = i18n.t('upgrade_page_views_order_components_submit_button_356');
            break;
          case this.payTypeConfig.StripeCheckOut:
            text = i18n.t('upgrade_page_views_order_components_submit_button_357');
            break;
          default:
            text = i18n.t('upgrade_page_views_order_components_submit_button_358');
            break;
        }
        this.setLoading(text);
        this.$confirm({
          content: i18n.t('upgrade_page_views_order_components_submit_button_359'),
          confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_360'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(() => {
            window.fbq('track', 'InitiateCheckout');
            if (this.skillInfo.userOnlineStatus !== 'Online') {
              setTimeout(() => {
                this.$confirm({
                  content:
                    i18n.t('upgrade_page_views_order_components_submit_button_361'),
                  confirmButtonText: i18n.t('upgrade_page_layout_header_42'),
                  cancelButtonText: i18n.t('upgrade_page_views_order_components_submit_button_362'),
                  closeOnClickModal: false,
                  closeOnPressEscape: false
                })
                  .then(() => {
                    this.$nextTick(() => {
                      this.loadingInstance.close();
                    });
                  })
                  .catch(() => {
                    this.createNormalOrder();
                  });
              }, 500);
            } else {
              this.createNormalOrder();
            }
          })
          .catch(() => {
            this.$nextTick(() => {
              this.loadingInstance.close();
            });
          });
      }
    },
    /**
     * @description: 支付訂單
     * @param {type}
     * @return:
     */
    payOrder() {
      const { orderInfo } = this;
      if (orderInfo.paymentStatus === 'NoNeed') {
        // 不需要實際支付
        this.gotoChat();
        return;
      }
      if (!this.orderNo) {
        // 新建訂單支付
        this.submitPay();
        return;
      }
      // 待支付訂單支付
      this.exchangePaymentNonce();
    },
    submitPay() {
      this.$nextTick(() => {
        // TODO:
        // 無法完成二次支付，/payment/order/detail無法返回正常值
        // this.$router.replace({
        //   name: 'orderSubmit',
        //   query: { ...this.$route.query, orderNo: this.orderInfo.orderNo },
        // });
        if (this.payType === this.payTypeConfig.FUN_POINT) {
          // console.log(
          //   'document.querySelector',
          //   document.querySelector('#funpoint-form')
          // );
          document.querySelector('#funpoint-form').submit();
        } else {
          document.querySelector('#payment-form').submit();
        }
      });
    },
    /**
     * @description: 換取藍星支付token
     * @param {type}
     * @return:
     */
    exchangePaymentNonce() {
      const { orderNo } = this;
      if (!orderNo) return;
      this.$http
        .get('/payment/order/detail', { orderNo })
        .then(({ data }) => {
          if (data && data.nonce) {
            this.orderInfo.paymentCheckCode = data.nonce;
            this.submitPay();
          } else {
            this.$nextTick(() => {
              this.loadingInstance.close();
            });
          }
        })
        .catch(() => {
          this.$nextTick(() => {
            this.loadingInstance.close();
          });
        });
    },
    /**
     * @description: 余额不足是否充值
     */
    recharge() {
      this.$confirm({
        content: i18n.t('upgrade_page_views_order_components_submit_button_363', [this.accountInfo.currencyKind,this.accountInfo.balance]),
        title: i18n.t('upgrade_page_views_order_components_submit_button_364'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_365'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42')
      })
        .then(() => {
          this.$router.push({
            name: 'Saving',
            query: {
              redirect: encodeURIComponent(location.href)
            }
          });
        })
        .catch(() => {});
    },
    // 下單頁下單錯誤處理
    showFailMessage(err) {
      switch (err.code) {
        case 721:
          this.$confirm({
            content:
              i18n.t('upgrade_page_views_order_components_submit_button_366'),
            confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_367'),
            showCancelButton: false
          });
          break;
        case 701:
          this.recharge();
          break;
        case 435:
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_368'));
          break;
        case 450:
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_369'));
          break;
        case 451:
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_370'));
          break;
        default:
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
          break;
      }
    },
    /**
     * @description: 检测用户是否已绑定手机号
     */
    isBindPhone() {
      if (this.userInfo.phoneNumber) return true;
      return new Promise(resolve => {
        this.$store.dispatch('app/getUserInfo').then(({ data }) => {
          if (data) {
            this.SET_USER_INFO(data);
            if (data.phoneNumber) {
              resolve(true);
            }
          } else {
            resolve(false);
          }
        });
      });
    },
    gotoChat() {
      this.$util.openChatWindow(this.userInfo.uuid, this.skillInfo.userUuid);
    },
    reportInviterInfo() {
      try {
        let uuid = this.$store.state.app.userInfo.uuid;
        getInviterUuid({ uuid }).then(({ data }) => {
          this.$adjust('web_order_paid', {
            inviterUuid: data && data.invitedUuid ? data.invitedUuid : 0,
            current_uuid: uuid,
            methods: 'banlance'
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 打開tappay支付彈窗
    openTappayDialog() {
      this.$refs.tappay.openDialog();
      this.closeLoading();
    },
    // tappay支付
    async tappayRecharge(config) {
      const { remember, prime, cardId } = config;
      const { count, skillId } = this;
      const href =
        process.env.VUE_APP_ENV === 'development'
          ? 'https://test.nicee.tw' + location.pathname + location.search
          : location.href;
      const successUrl = href + '&isTappay=true';
      const params = {
        count,
        playerSkillId: skillId,
        paymentMethod: this.payType,
        priceType: this.skillInfo.selfSpreadFlag ? 'SelfSpread' : null,
        couponUuid: this.couponUuid,
        skillPrice: this.skillPrice.id ? this.skillPrice : undefined,
        tabPalPrime: prime,
        successUrl: successUrl
      };
      if (!cardId) {
        params['remember'] = remember;
      }
      this.$refs.tappay.closeDialog();
      this.setLoading();
      try {
        const { data } = await this.$http.post('/order/create', params);
        console.log('data', data);
        if (data && data.result && data.result.url) {
          window.open(data.result.url, '_self');
        } else {
          this.closeLoading();
          return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
        }
      } catch (error) {
        console.log('error', error);
        this.closeLoading();
        return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
      }
    },
    // 支付中
    setLoading(message) {
      const text = message || i18n.t('upgrade_page_views_order_components_submit_button_352');
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: text,
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 关闭loading状态
    closeLoading() {
      this.loadingInstance.close();
    },
    // 生成paypal支付按鈕
    renderButton() {
      if (this.paypalButton) {
        this.paypalButton.close();
      }
      const paypalScriptConfig = {
        'client-id': process.env.VUE_APP_CLIENT_ID,
        'disable-funding': 'credit,card',
        currency: 'TWD',
        intent: 'authorize'
      };
      // 按鈕相關設置
      const buttonConfig = {
        style: {
          shape: 'pill',
          height: 45
        },
        // 創建paypal訂單
        createOrder: this.paypalCreateOrder,
        // 支付成功
        onApprove: this.paySuccess,
        onError: () => {
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_372'));
          this.closeLoading();
        },
        onCancel: () => {
          this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_373'));
          this.closeLoading();
        },
        onClick: (data, actions) => {
          if (this.skillInfo.userOnlineStatus !== 'Online') {
            return this.$confirm({
              content:
                i18n.t('upgrade_page_views_order_components_submit_button_361'),
              confirmButtonText: i18n.t('upgrade_page_layout_header_42'),
              cancelButtonText: i18n.t('upgrade_page_views_order_components_submit_button_362'),
              closeOnClickModal: false,
              closeOnPressEscape: false
            })
              .then(() => {
                // this.closeLoading();
                return actions.reject();
              })
              .catch(async () => {
                this.setLoading(i18n.t('upgrade_page_views_order_components_submit_button_374'));
                return this.payPalRecharge(actions);
              });
          } else {
            this.setLoading(i18n.t('upgrade_page_views_order_components_submit_button_374'));
            return this.payPalRecharge(actions);
          }
        }
      };
      // 用來渲染按鈕的元素id
      const id = '#' + this.submitId;
      loadScript(paypalScriptConfig)
        .then(paypal => {
          this.paypalButton = paypal.Buttons(buttonConfig);
          this.paypalButton.render(id).catch(error => {
            console.error('failed to render the PayPal Buttons', error);
          });
        })
        .catch(error => {
          console.error('failed to load the PayPal JS SDK script', error);
        });
    },
    // 创建paypal订单
    paypalCreateOrder(data, actions) {
      return actions.order
        .create({
          purchase_units: [
            {
              amount: {
                value: this.payPrice
              },
              invoice_id: this.orderInfo.orderNo
            }
          ]
        })
        .then(async data => {
          return data;
        });
    },
    // paypal支付成功
    paySuccess(data, actions) {
      actions.order.authorize().then(authorization => {
        var authorizationID =
          authorization.purchase_units[0].payments.authorizations[0].id;
        return this.$http
          .post('/payment/reportPayPalResult', {
            orderId: data.orderID,
            authId: authorizationID,
            orderNo: this.orderInfo.orderNo
          })
          .finally(() => {
            this.$message.success(i18n.t('upgrade_page_views_order_components_submit_button_375'));
            this.gotoChat();
            this.closeLoading();
          });
      });
    },

    async payPalRecharge(actions) {
      // 是否已綁定手機
      const isBind = await this.isBindPhone();
      if (!isBind && this.isFromNew) {
        this.$nextTick(() => {
          this.loadingInstance.close();
        });
        this.$message(i18n.t('upgrade_page_views_order_components_submit_button_350'));
        BindPhone({ isOrder: true }).then(() => {
          this.$emit('bindPhoneComplete');
        });
        this.closeLoading();
        return actions.reject();
      } else {
        const { count, skillId } = this;
        const params = {
          count,
          playerSkillId: skillId,
          paymentMethod: this.payType,
          priceType: this.skillInfo.selfSpreadFlag ? 'SelfSpread' : null,
          couponUuid: this.couponUuid,
          skillPrice: this.skillPrice.id ? this.skillPrice : undefined
        };
        const { data } = await this.$http.post('/order/create', params);
        if (data) {
          this.orderInfo = data;
          return actions.resolve();
        } else {
          return actions.reject();
        }
      }
    },
    //stripe金流
    async stripeRecharge() {
      this.setLoading();
      const { count, skillId } = this;
      let addr = new URL(location.href);
      console.log(addr);
      addr.searchParams.delete('stripe');
      const successUrl = addr.href + '&stripe=true';
      const cancelUrl = addr.href + '&stripe=false';
      // const successUrl = `${location.origin}${location.pathname}?&isStripe=true&price=${this.checkedNumber}&`;
      // const cancelUrl = `${location.origin}${location.pathname}?&isStripe=false&price=${this.checkedNumber}&`;
      const params = {
        count,
        playerSkillId: skillId,
        paymentMethod: this.payType,
        priceType: this.skillInfo.selfSpreadFlag ? 'SelfSpread' : null,
        couponUuid: this.couponUuid,
        skillPrice: this.skillPrice.id ? this.skillPrice : undefined,
        successUrl: successUrl,
        cancelUrl: cancelUrl
      };
      try {
        const { data } = await this.$http.post('/order/create', params);
        if (data && data.sessionId) {
          window.open(data.sessionId, '_self');
        } else {
          this.closeLoading();
          return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
        }
      } catch (error) {
        console.log('error', error);
        this.closeLoading();
        return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
      }
    },
    //fomopay金流
    async fomopayRecharge() {
      this.setLoading();
      const { count, skillId } = this;
      let addr = new URL(location.href);
      const successUrl = addr.href + '&fomo=true';
      const cancelUrl = addr.href + '&fomo=false';
      addr.searchParams.delete('fomo');
      const params = {
        count,
        playerSkillId: skillId,
        paymentMethod: this.payType,
        priceType: this.skillInfo.selfSpreadFlag ? 'SelfSpread' : null,
        couponUuid: this.couponUuid,
        skillPrice: this.skillPrice.id ? this.skillPrice : undefined,
        successUrl: successUrl,
        cancelUrl: cancelUrl
      };
      try {
        const { data } = await this.$http.post('/order/create', params);
        if (data && data.result && data.result.url) {
          window.open(data.result.url, '_self');
        } else {
          this.closeLoading();
          return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
        }
      } catch (error) {
        console.log('error', error);
        this.closeLoading();
        return this.$message.error(i18n.t('upgrade_page_views_order_components_submit_button_371'));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.order-submit {
  padding: 0 12px 32px;
  background: #ffffff;
}
.submit-button {
  position: relative;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 18px;
  @include button-yellow;
  width: 100%;
  height: 46px;
  border-radius: 30px !important;
}
.payPay-button-box {
  position: absolute;
  width: 216px;
  height: 46px;
  top: 0;
  opacity: 0;
}
.recharge-container-1 {
  display: flex;
  margin-bottom: 11px;
  .recharge-text-1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #999999;
  }
  .recharge-balance {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
  }
  img {
    height: 18px;
    margin: 0 4px 0 7px;
  }
}
.recharge-container-2 {
  font-size: 16px !important;
  line-height: 19px !important;
  color: #333333 !important;
}
.pay-loading {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  text-align: center;
  color: #eeeeee;
  font-size: 20px;
}
.loading-icon {
  margin: 0 auto 10px;
}
.over-lazy {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
@media screen and (min-width: 600px) {
  .order-submit {
    padding: 0;
    margin-top: 30px;
    background: none;
  }
  .submit-button {
    width: 216px;
    height: 46px;
    border-radius: 4px;
    font-size: 16px;
  }
}
</style>
